import { css } from '@linaria/core'
import { type FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IconButton } from '#components/IconButton'
import { AccessibilityDropdown } from '#features/AccessibilityDropdown'
import { AdditionalSettings } from '#features/AdditionalSettings'
import { HeaderTabsContainer as HeaderTabs, HeaderToolsContainer as HeaderTools } from '#features/AppLayout'
import { ConfiguratorExportFavoritesModal } from '#features/FavoriteSets/ConfiguratorExportFavoritesModal'
import { ConfiguratorImportFavoriteSetModal } from '#features/FavoriteSets/ConfiguratorImportFavoriteSetModal'
import { ConfigurationFeedbackDropdown } from '#features/Feedback/ConfigurationFeedbackDropdown'
import { HomeHeader } from '#features/Header/HomeHeader'
import { HeaderTabsContainer } from '#features/HeaderTabsContainer'
import { HeaderToolsContainer } from '#features/HeaderToolsContainer'
import { UserDropdown } from '#features/User/UserDropdown'
import { useIsAuthenticated } from '#features/User/userManager'
import ImportIcon from '#icons/cloud-upload-outline-24.svg'
import ExportIcon from '#icons/download-24.svg'
import { CallingSystemExit } from './CallingSystemExit'

const feedbackClass = css`
  display: flex;
  align-items: center;
`

const FavoritesElements: FC<{ onImport: () => void; onExport: () => void }> = ({ onImport, onExport }) => {
  const { t } = useTranslation()
  return (
    <>
      <IconButton iconUrl={ExportIcon} iconFirst className="_export" title={undefined} onClick={onExport}>
        {t('user.action.export-favorites', 'Export Favorites')}
      </IconButton>
      <IconButton iconUrl={ImportIcon} iconFirst className="_import" title={undefined} onClick={onImport}>
        {t('user.action.import-favorites', 'Import Favorites')}
      </IconButton>
    </>
  )
}

export const AppHeader: FC = () => {
  const [userDropdownOpen, setUserDropdownOpen] = useState(false)
  const [favImportModalOpen, setFavImportModalOpen] = useState(false)
  const [favExportModalOpen, setFavExportModalOpen] = useState(false)
  const isAuthenticated = useIsAuthenticated()

  return (
    <>
      {favExportModalOpen && <ConfiguratorExportFavoritesModal open={favExportModalOpen} onOpenChange={setFavExportModalOpen} />}
      {favImportModalOpen && <ConfiguratorImportFavoriteSetModal open={favImportModalOpen} setOpen={setFavImportModalOpen} />}

      <HomeHeader />
      {isAuthenticated && (
        <HeaderTabs>
          <HeaderTabsContainer />
        </HeaderTabs>
      )}
      <HeaderTools>
        <HeaderToolsContainer>
          <ConfigurationFeedbackDropdown className={feedbackClass} />
          <AccessibilityDropdown className={feedbackClass}>
            <AdditionalSettings />
          </AccessibilityDropdown>
          <UserDropdown className={feedbackClass} isOpen={userDropdownOpen} setIsOpen={setUserDropdownOpen}>
            <FavoritesElements
              onExport={() => {
                setUserDropdownOpen(false)
                setFavExportModalOpen(true)
              }}
              onImport={() => {
                setUserDropdownOpen(false)
                setFavImportModalOpen(true)
              }}
            />
          </UserDropdown>
          <CallingSystemExit />
        </HeaderToolsContainer>
      </HeaderTools>
    </>
  )
}
